import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import CollapseInformation from './CollapseInformation';
import CollapseInformationExample from './CollapseInformationExample';

interface IModalLegalProps {
    pdf: string;
    toggle: any;
    open: boolean;
    coverage: number;
    topeAnual: number;
    consultation: boolean;
    ambulatory: boolean;
    ambulatoryFull: boolean;
    hospitable: boolean;
    maternity: boolean;
    kinesiologyHealth: boolean;
}

export default function ModalMedicalCoverage(props: IModalLegalProps) {
  const { pdf, open = true, toggle, coverage, topeAnual, consultation, ambulatory, ambulatoryFull, hospitable, maternity, kinesiologyHealth } = props;

  return (
    <Modal modalClassName="format-new-modal" isOpen={open} size="lg" fade={false}>
      <div className="modal-header">
        <div className="close-modal-header w-100 d-flex text-align-left justify-content-between">
            <img
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_chevron.svg"
                alt=""
                onClick={toggle(false)}
            />
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
                alt=""
                onClick={toggle(false)}
            />
        </div>
      </div>
      <ModalBody className="px-16">
        <div className="modal-title d-flex justify-content-start align-items-center align-content-center">
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_salud-filled.svg"
                alt=""
            />
            <h3 className="px-20 p-0 m-0">Coberturas médicas</h3>
        </div>
        <div className="modal-metadata mt-13">
            <p>
                Si necesitas más información: llamanos al
                <a href="tel:800380800">800 380 800</a>
            </p>
            <a target="_blank" href={pdf} className="d-flex align-content-center align-items-center px-14" rel="noreferrer">
                Descargar PDF propuesta completa seguro
                <i className="material-icons">chevron_right</i>
            </a>
        </div>
        <div className="mt-20">
            <CollapseInformation title="Gastos ambulatorios" coverage={coverage} topeMaximoAnual={topeAnual} consultation={consultation} ambulatory={ambulatory} ambulatoryFull={ambulatoryFull} information={{
                "Consulta médica": {
                    "TP": consultation ? "UF " + (coverage === 50 ? "0,5" : "1") : (ambulatory || ambulatoryFull) ? "UF 1" : "-",
                    "TMA": (consultation || ambulatory || ambulatoryFull) ? "UF " + topeAnual : "-"
                },
                "Cirugía ambulatoria": {},
                "Exámenes ambulatorios": {},
                "Procedimientos de diagnósticos": {},
                "Procedimientos quirúrgicos": {}
            }}/>
            {hospitable ? <CollapseInformation title="Gastos hospitalarios" coverage={coverage} topeMaximoAnual={topeAnual} consultation={consultation} ambulatory={ambulatory} ambulatoryFull={ambulatoryFull} information={{
                "Día Cama Medicina": {
                    "TP": "UF " + (coverage === 50 && consultation ? "1,5 diario" : "3 diarios"),
                },
                "Servicios Hospitalarios": {},
                "Honorarios Médicos": {},
                "Insumos": {},
                "Ambulancia": {}
            }}/>: null}
            {maternity ? <CollapseInformation title="Maternidad" coverage={coverage} topeMaximoAnual={topeAnual} consultation={consultation} ambulatory={ambulatory} ambulatoryFull={ambulatoryFull} information={{
                "Parto Normal": {
                    "TP": "UF " + (coverage === 50 && consultation ? "10" : "20"),
                },
                "Cesárea": {
                    "TP": "UF " + ((coverage === 70 && !consultation) || ambulatoryFull ? "30" : "15"),
                },
                "Aborto no Provocado": {
                    "TP": "UF " + (coverage === 50 && consultation ? "5" : "10")
                }
            }} finalNote="Nota: Para que el asegurado titular o cónyuge asegurado tenga derecho a este beneficio, la fecha probable de inicio del embarazo debe ser posterior a la fecha de inicio de la vigencia de esta cobertura para el asegurado que se aplica."/> : null}
            
            {kinesiologyHealth ? <CollapseInformation title="Salud Mental" tooltip={false} coverage={coverage} topeMaximoAnual={topeAnual} consultation={consultation} ambulatory={ambulatory} ambulatoryFull={ambulatoryFull} information={{
                "Consultas (psiquiatría/psicología)": {
                    "TP": consultation ? "UF " + (coverage === 50 ? "0,4" : "0,8") : ambulatoryFull ? "UF 0,8" : "-",
                    "TMA": consultation ? "UF " + (coverage === 50 ? "4" : "8") : ambulatoryFull ? "UF 8" : "-",
                }
            }}/> : null}
            {!ambulatory ? <CollapseInformation title="Beneficios Adicionales" tooltip={false} coverage={coverage} topeMaximoAnual={topeAnual} consultation={consultation} ambulatory={ambulatory} ambulatoryFull={ambulatoryFull} information={{
                "Cristales, marcos y lentes de contacto": {
                    "TP": consultation && coverage === 50 ? "UF 5" : "-",
                    "TMA": "UF " + (coverage === 50 && consultation ? "1,5" : ambulatoryFull ? "3": "-")
                },
                "Prótesis y Órtesis": {
                    "TMA": "UF " + (coverage === 50 && consultation ? "10" : "20")
                },
                "Cirugía Lasik": {
                    "TMA": "UF " + (coverage === 50 && consultation ? "5" : "10")
                },
                "Cirugía por Obesidad": {
                    "TP": "UF " + (coverage === 50 && consultation ? "5" : "10"),
                    "TMA": "UF " + (coverage === 50 && consultation ? "5" : "10")
                }
            }} finalNote="Los topes de cada cobertura no podrán ser superiores al tope anual por beneficiario."/> : null}
        </div>
        <div className="modal-title mt-60 mb-25 d-flex justify-content-start align-items-center align-content-center">
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_salud-filled.svg"
                alt=""
            />
            <h3 className="px-20 p-0 m-0">Cómo funciona el reembolso</h3>
        </div>
        <p className="px-14 mb-16">El reembolso ocurre después de la cobertura de tu Isapre o Fonasa y puedes usarlo después de 30 días/1 mes de contratar el plan.</p>
        <CollapseInformationExample first={true} coverage={coverage} which="gte" />
        <CollapseInformationExample coverage={coverage} which="lt" />
      </ModalBody>
    </Modal>
  );
}
